export default __webpack_public_path__ + "static/media/port-emission-taxation-icon.ac7a7fb7.png";